import React, { useState, useEffect, useRef, useContext } from 'react';
import { Link } from 'react-router-dom';
import { PageSettings } from '../../../config/page-settings';
import classnames from 'classnames';
import { TabContent, TabPane, Nav, NavItem, NavLink, Card, CardText, CardBody, CardTitle, CardHeader, CardFooter, Button, } from 'reactstrap';


function Sttplandetail(props) {
    const context = useContext(PageSettings)
    const [activePill, setactivePill] = useState('1');
    const togglePill = (pill) => {
        if (pill === '1' && activePill !== pill) {

        }
        else if (pill === "2" && activePill !== pill) {

        }
        else if (pill === "3" && activePill !== pill) {

        }
        else if (pill === "4" && activePill !== pill) {

        }
        else if (pill === "5" && activePill !== pill) {

        }
        else if (pill === "6" && activePill !== pill) {

        }

        if (setactivePill !== pill) {
            setactivePill(pill);
        }
    }
    useEffect(() => {
        context.handleSetPageSidebar(false)
        context.handleSetPageHeader(false)
        context.handleSetPageContentFullWidth(true);
        return () => {
            context.handleSetPageSidebar(true)
            context.handleSetPageHeader(true)
            context.handleSetPageContentFullWidth(false);
        }
    }, [])

    return (
        <div id="page-container" class="fade page-sidebar-fixed page-header-fixed login-v1">
            <div className="container-fluid">
                <div>
                    <h1 className="signup-header">Sign up for STT</h1>
                    <h4 className="signup-subheader">Choose your plan and upgrade or Cancel any time</h4>
                </div>
                <Nav tabs className="nav-tabs-inverse" >
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activePill === '1' })}
                            onClick={() => { togglePill('1'); }}
                        >
                            <span className="d-sm-none">Profile</span>
                            <span className="d-sm-block d-none ">Profile</span>
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activePill === '2' })}
                            onClick={() => { togglePill('2'); }}
                        >
                            <span className="d-sm-none">Labels</span>
                            <span className="d-sm-block d-none ">Labels</span>
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activePill === '3' })}
                            onClick={() => { togglePill('3'); }}
                        >
                            <span className="d-sm-none">Profile</span>
                            <span className="d-sm-block d-none ">Profile</span>
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activePill === '4' })}
                            onClick={() => { togglePill('4'); }}
                        >
                            <span className="d-sm-none">Labels</span>
                            <span className="d-sm-block d-none ">Labels</span>
                        </NavLink>
                    </NavItem>
                </Nav>
            </div>
        </div>

    )

}

export default Sttplandetail;